// export const hostAddress = "http://localhost:8080";
// export const hostAddress = "https://avc-team.com.ua/api";
export const hostAddress = "https://avc-team-backend.herokuapp.com";
